import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import MainHeader from "./components/header/MainHeader.vue";
import NavigationBar from "./components/header/NavigationBar.vue";
import MainFooter from "./components/footer/MainFooter.vue";
import { useI18n } from "vue-i18n";
import { ref, onMounted } from "vue";

import { hamtaMiljo } from "./api";

export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

useI18n({ useScope: "global" });

const miljo = ref<string>(""); 

onMounted(async () => {
	hamtaMiljo()
	.then( data => {
		miljo.value = data as string;
	    if (miljo.value !== "" && miljo.value !== "prod") {
	      document.title =  `[${miljo.value}] ${document.title}`;
	    }
	}).catch((error: string) => {
    console.log(`Hämtning av aktuell miljö misslyckades: ${error}`);
  });
});


return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(MainHeader, { miljo: miljo.value }, null, 8, ["miljo"]),
    _createVNode(NavigationBar),
    _createVNode(_component_router_view),
    _createVNode(MainFooter)
  ], 64))
}
}

})